<template>
    <button class="btn btn-danger btn-circle" :title="'حذف '+name" data-toggle="tooltip" @click="doDelete()">
        <i v-if="!deleting" class="dripicons dripicons-tag-delete"></i>
        <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
</template>
<script>
    export default {
        props : {
            //The delete request uri
            requestUri : {type: String, required: true},

            //Action for run after complete delete http request
            afterDelete : {required: false},

            //The item name
            name: {type: String, required: false},

            //The title of the row
            title: {type: String, required: false},

            //Redirect target
            redirect: {type: String, required: false}
        },
        data(){
            return {
                deleting: false
            }
        },
        computed: {
            _name(){
                return this.name ? this.name : 'آیتم';
            },
            confirmMessage(){
                if(this.title){
                    return 'آیا می خواهید ' + this._name + ' "' + this.title + '" را حذف نمایید؟';
                }else{
                    return 'آیا می خواهید این ' + this._name + ' را حذف نمایید؟'
                }
            },
            doneMessage(){
                if(this.title){
                    return this._name + ' "' + this.title + '" با موفقیت حذف شد.'
                }else{
                    return this._name + ' مورد نظر با موفقیت حذف شد.'
                }
            }
        },
        methods: {
            doDelete(){

                this.$swal({
                    title: 'آیا مطمئن هستید؟',
                    text: this.confirmMessage,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'بله',
                    cancelButtonText: 'خیر',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleting = true;
                        this.axios.delete(this.requestUri)
                            .then(response => {
                                this.$moshaToast(response.data.message,{
                                    position: 'top-left',
                                    type: 'success',
                                });
                                if(typeof this.afterDelete == 'function'){
                                    this.afterDelete();
                                }else if(this.redirect){
                                    window.location.href = this.redirect;
                                }
                            })
                            .catch((error) => {
                                this.$swal({
                                    title: 'ناموفق',
                                    text: error.response.data.message,
                                    icon: 'error',
                                    confirmButtonText: 'باشه',
                                });
                            })
                            .then(() => {
                                this.deleting = false;
                            });
                    }
                });
            }
        },
    }
</script>
<style scoped>

</style>
